import React, { useMemo, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Api, getSession, updateSession } from '../../api/Assinafy';
import { Alert, Button, Form, Icon, Input } from '../../components';
import { Page } from '../../layout';
import { dateFormat } from '../../utils/Formats';

import '../Login/styles.scss';

const WorkspaceCreate = () => {
  const navigate = useNavigate();
  const { user } = getSession();

  const suggestedWorkspaceName = useMemo(() => {
    return (user?.email || '').slice(0, 6);
  }, [user?.email]);

  const scheduledForDeletion = !!user?.to_be_deleted_at;

  const [reactivating, setReactivating] = useState(false);
  const [reactivateError, setReactivateError] = useState('');

  useEffect(() => {
    if (!user) {
      navigate('/', { replace: true });
    }
  }, [navigate, user]);

  const handleSubmit = (formData) => {
    const payload = {
      ...formData,
      name: formData?.name || suggestedWorkspaceName,
    };

    return Api('accountUser/addAccount')(payload).then(({ status }) => {
      if (status === 200) {
        navigate('/dashboard', { replace: true });
      }
    });
  };

  const handleReactivate = async () => {
    if (reactivating) return;

    setReactivating(true);
    setReactivateError('');

    try {
      const { status } = await Api('user/cancelDeleteSelf')();
      if (status !== 200) {
        throw new Error();
      }

      try {
        const { data: { data } } = await Api('user/getSelf')();
        updateSession({ user: data.user, accounts: data.accounts });
      } catch {
        updateSession({ user: { ...user, to_be_deleted_at: null } });
      }

      navigate('/dashboard', { replace: true });
    } catch (error) {
      setReactivateError(
        error?.response?.data?.message ||
          'Não foi possível reativar a conta. Tente novamente.',
      );
      setReactivating(false);
    }
  };

  if (scheduledForDeletion) {
    return (
      <Page
        className="page-sign page-sign-wide"
        title="Conta com exclusão agendada."
        opening={
          <>
            Essa conta está com processo de exclusão agendado para{' '}
            <strong>{dateFormat(user.to_be_deleted_at)}</strong>.
            <br />
            Você pode desistir do cancelamento reativando a conta abaixo.
          </>
        }
      >
        <div className="workspace-reactivate">
          <Alert show={!!reactivateError} variant="warning" onClose={() => setReactivateError('')}>
            {reactivateError}
          </Alert>

          <Button
            variant="primary"
            size="lg"
            onClick={handleReactivate}
            loading={reactivating}
          >
            Reativar conta
            <Icon id="icon-arrow_forward" className="ms-2" size="24" />
          </Button>
        </div>
      </Page>
    );
  }

  return (
    <Page
      className="page-sign"
      title="Você não tem um workspace"
      opening="Crie seu workspace para usar a Assinafy."
    >
      <Form
        id="form-workspace-create-empty-state"
        className="form-sign"
        onSubmit={handleSubmit}
        size="lg"
        data={{
          name: suggestedWorkspaceName,
        }}
        controls={[
          {
            Component: Input,
            name: 'name',
            placeholder: 'Nome do Workspace',
            required: true,
            autoFocus: true,
            defaultValue: suggestedWorkspaceName,
          },
        ]}
        buttons={[
          {
            variant: 'primary',
            submit: true,
            children: (
              <>
                Criar Workspace
                <Icon id="icon-arrow_forward" className="ms-2" size="24" />
              </>
            ),
          },
        ]}
      />
    </Page>
  );
};

export default WorkspaceCreate;
